import { GALLERY_CONSTS, INPUT_TYPES } from '../utils/constants';
import { hasVerticalPlacement } from '../../common/constants/placements';
import { createOptions } from '../utils/utils';
export default {
  title: 'Text Box Height Calculation Type',
  description: "Set the calc type (manual or automatic) to use when calculating the textbox height",
  isRelevant: function isRelevant(styleParams) {
    return styleParams.isVertical && styleParams.groupSize === 1 && !styleParams.oneRow && hasVerticalPlacement(styleParams.titlePlacement) && (styleParams.allowTitle || styleParams.allowDescription);
  },
  type: INPUT_TYPES.OPTIONS,
  options: createOptions('textBoxHeightCalculationOptions'),
  "default": GALLERY_CONSTS.textBoxHeightCalculationOptions.AUTOMATIC
};